/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Faq_Q1Inputs */

const en_simple_oto_faq_q1 = /** @type {(inputs: Simple_Oto_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I really cannot build software. Does this work for me?`)
};

const id_simple_oto_faq_q1 = /** @type {(inputs: Simple_Oto_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saya benar-benar tidak bisa membuat aplikasi. Bisa?`)
};

/**
* | output |
* | --- |
* | "I really cannot build software. Does this work for me?" |
*
* @param {Simple_Oto_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_faq_q1 = /** @type {((inputs?: Simple_Oto_Faq_Q1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Faq_Q1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_faq_q1(inputs)
	return en_simple_oto_faq_q1(inputs)
});